<div class="source_code-header">
  {{ 'documents.editor.sourceCode' | translate }}

  <button class="btn-M btn-text icon-only source_code-button--type-close" (click)="modal.dismiss()">
    <i class="fal fa-xmark"></i>
  </button>
</div>

<textarea name="source_code" id="source_code" #srcCodeTextArea class="source_code-textarea" [value]="srcCode"></textarea>

<div class="source_code-button__box">
  <button class="btn-M btn-text" (click)="modal.dismiss()">{{ 'button.cancel' | translate }}</button>
  <button class="btn-M btn-filled" (click)="exportSrcCode()">{{ 'button.save' | translate }}</button>
</div>
